const fakePicture = [
    {    
        _id:"64243f9c907873df3d39b4b7",
        trash_picture: "/images/tasdivers_plage.jpg",
        postId:'64243f9c907873df3d39b4b7'
    },
    {    
        _id:"64243f9c907873df3d39b4c7",
        trash_picture: "/images/bidons.jpg",
        postId:'64243f9c907873df3d39b4b78'
    },
    {    
        _id:"64243f9c907r73df3d39b4c7",
        trash_picture: "/images/tasmeubles.jpg",
        postId:'64243ddd907873df3d39b48f'
    }
]

export default fakePicture;